export class BankAccountModel {
  constructor(
    public id: number = 46,
    public bankCountryCode: string = null,
    public bankNumber: string = null,
    public bankName: string = null,
    public bankType: string = null,
    public accountNumber: string = null,
    public accountHolder: string = null,
    public ribKey: string = null,
    public paiementMode: string = null,
    public accountDRGLT: string = null,
    public accountGen: string = null
  ) {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
